export const alertsParser = (response) => {
    if (!response || !response.result) {
        return {
            results: [],
            totalCount: 0,
            currentPage: 0,
            totalPages: 0,
        };
    }

    const { alerts, totalCount, currentPage, totalPages } = response.result;

    return {
        results: alerts || [],
        totalCount: totalCount || 0,
        currentPage: currentPage || 0,
        totalPages: totalPages || 0,
    };
};
